module.exports = __webpack_public_path__ + "media/components/country-flag/static/dg-5adc9e04ca358ce70d351deb910bde5f.svg";